// @vue/component
export default {
  name: 'AddressBookItemEditForm',

  props: {
    addressBookItem: {
      type: Object,
      default: () => [],
    },
  },

  data() {
    return {
      addressBookEditForm: {
        description: this.addressBookItem.description,
        vip: this.addressBookItem.vip,
        number: this.addressBookItem.uuid,
      },
      rules: {
        description: [
          { required: true, message: 'Pole jest wymanage', trigger: 'blur' },
        ],
      },
    };
  },

  computed: {
    isLoading() {
      return this.$store.getters['global/pendingAsyncStoreActions'].includes([
        'addressBook/updateNumber',
        'addressBook/getList']);
    },
    paramsToUpdate() {
      return {
        ...this.addressBookEditForm, vip: this.addressBookEditForm.vip.toString(),
      };
    },
  },

  methods: {
    cancelForm() {
      this.$refs.addressBookEditForm.resetFields();
      this.$emit('closeModal');
    },
    submitForm() {
      this.$refs.addressBookEditForm.validate(async (valid) => {
        if (valid) {
          await this.$store.dispatch('addressBook/updateNumber', this.paramsToUpdate);
          this.$message({
            type: 'success',
            message: `Numer ${this.addressBookItem.num_a} został zmodyfikowany`,
          });
          await this.$store.dispatch('addressBook/getList');
          this.$emit('closeModal');
        }
      });
    },
  },

};
